// extracted by mini-css-extract-plugin
export default {"privacyPoliceWrap":"PrivacyPolicy_privacyPoliceWrap__doJ9F","privacyPolice":"PrivacyPolicy_privacyPolice__j0LY1"};